import { FC, useState } from 'react';
import { Box } from '@mui/material';
import styles from 'features/statistics/ui/ClientPanel.module.css';
import InfoIcon from '@mui/icons-material/Info';


export const ClientPanel: FC = () => {
    return (
        <Box>
            <Box className={styles.headerBox}>
                <Box className={styles.cardBox}>
                    <p className={styles.cardBoxInfo}><span>68</span></p>
                    <p className={styles.sign}>NPS</p>
                    <p className={styles.textDescription}>индекс лояльности</p>
                </Box>
                <Box className={styles.cardBox}>
                    <p className={styles.cardBoxInfo}><span>84/20</span></p>
                    <p className={styles.sign}>SL</p>
                    <p className={styles.textDescription}>уровень сервиса</p>
                </Box>
                <Box className={styles.cardBox}>
                    <p className={styles.cardBoxInfo}><span>92</span>%</p>
                    <p className={styles.sign}>CS</p>
                    <p className={styles.textDescription}>уровень удовлетворенности работой сотрудника мед. пульта</p>
                </Box>
            </Box>

            <Box className={styles.claimContainer}>
                <Box className={styles.rightBox}>
                    <Box className={styles.textBox}>
                        <p>Количество претензионных обращений</p>
                        <p className={styles.textColor}>2 обращения</p>
                    </Box>
                    <Box className={styles.textBox}>
                        <p>Частота претензий</p>
                        <p className={styles.textColor}>0,85%</p>
                    </Box>
                </Box>
                <Box className={styles.leftBox}>
                    Таблица
                </Box>
            </Box>

            <Box className={styles.infoBox}>
                <span className={styles.icon}><InfoIcon /></span>
                <Box>
                    <p><span>Претензией</span> считается обращение по любому каналу связи с жалобой на любого участника сервиса по данному договору страхование: врача, клинику, сотрудника страховой компании, а так же на условия страхования.</p>
                    <p>Частота претензий = кол-во претензий / кол-во застрахованных по договору. Средняя частота претензий по портфелю 1,3%</p>
                </Box>

            </Box>


        </Box>
    );
};

export default ClientPanel;